import { ACTIONS as activityItemsActions } from 'actions/activity-items';
import { ACTIONS as addHealthCheckData } from 'actions/add-health-check-data';
import { ACTIONS as avMonitorActions } from 'actions/av-monitor';
import { ACTIONS as avSessionsActions } from 'actions/av-sessions';
import { ACTIONS as avTokensActions } from 'actions/av-tokens';
import { ACTIONS as primaryMediaProviderActions } from 'actions/backend-media-provider';
import { ACTIONS as beltsActions } from 'actions/belts';
import { ACTIONS as classroomStudents } from 'actions/classroom-students';
import { ACTIONS as classroomActions } from 'actions/classrooms';
import { ACTIONS as configActions } from 'actions/configs';
import { ACTIONS as curriculumPrograms } from 'actions/curriculum-programs';
import { ACTIONS as demoFeedbackActions } from 'actions/demo-feedback';
import { ACTIONS as disciplineActions } from 'actions/discipline';
import { ACTIONS as eventActions } from 'actions/events';
import { ACTIONS as examItemsActions } from 'actions/exam-activity-items';
import { ACTIONS as schoolExamHelpSheetsActions } from 'actions/exam-help-sheets';
import { ACTIONS as examLearnosityQuestionsActions } from 'actions/exam-learnosity-questions';
import { ACTIONS as examPerformance } from 'actions/exam-performance';
import { ACTIONS as feedbackActions } from 'actions/feedback';
import { ACTIONS as feedbackTagActions } from 'actions/feedback-tags';
import { ACTIONS as gatekeeperActions } from 'actions/gatekeeper';
import { ACTIONS as hmsTokenActions } from 'actions/hms-tokens';
import { ACTIONS as journeysActions } from 'actions/journeys';
import { ACTIONS as prefetchSheetActions } from 'actions/learnosity-prefetch';
import { ACTIONS as learnosityQuestionsActions } from 'actions/learnosity-questions';
import { ACTIONS as learnositySessionAction } from 'actions/learnosity-sessions';
import { ACTIONS as learnosityWidgetsActions } from 'actions/learnosity-widgets';
import { ACTIONS as loginActions } from 'actions/login';
import { ACTIONS as logoutActions } from 'actions/logout';
import { ACTIONS as logoutEverywhereActions } from 'actions/logout-everywhere';
import { ACTIONS as masteryPlanActions } from 'actions/mastery-plan';
import { ACTIONS as monthlyProgress } from 'actions/monthly-progress';
import { ACTIONS as monthlyProgressV2 } from 'actions/monthly-progress-v2';
import { ACTIONS as otpActions } from 'actions/otp';
import { ACTIONS as parentOTP } from 'actions/parent-otp';
import { ACTIONS as passwordResetTokenAction } from 'actions/password-reset-token';
import { ACTIONS as practiceActions } from 'actions/practice-sheets';
import { ACTIONS as precallAnalysisActions } from 'actions/precall-analysis';
import { ACTIONS as predictiveSheetPost } from 'actions/predictive-sheet-fetch';
import { ACTIONS as programActions } from 'actions/program';
import { ACTIONS as ptmActions } from 'actions/ptm';
import { ACTIONS as ptmFeedbackActions } from 'actions/ptm-feedback';
import { ACTIONS as ptmScheduledDate } from 'actions/ptm-schedule-actions';
import { ACTIONS as sheetActions } from 'actions/sheets';
import { ACTIONS as studentClassActivitiesAction } from 'actions/student-class-activities';
import { ACTIONS as studentCoursesActions } from 'actions/student-courses';
import { ACTIONS as studentNodeAction } from 'actions/student-node';
import { ACTIONS as studentQuestionsSignedKey } from 'actions/student-questions-signed-key';
import { ACTIONS as teacherActions } from 'actions/teacher';
import { ACTIONS as teacherBadgesActions } from 'actions/teacher-badges';
import { ACTIONS as teacherStudents } from 'actions/teacher-students';
import { ACTIONS as ugsExperienceConfigActions } from 'actions/ugs-experience-config';
import { ACTIONS as vibeActions } from 'actions/vibe';
import { ACTIONS as videoResumeUrl } from 'actions/video-resume-url';
import { ACTIONS as whiteboardActions } from 'actions/whiteboards';
import { ACTIONS as worksheetActions } from 'actions/worksheet';
import { ACTIONS as worksheetAttemptsActions } from 'actions/worksheet-attempts';
import { ACTIONS as worksheetCurriculumActions } from 'actions/worksheet-curriculum';
import { ACTIONS as worksheetQuestionResponseInfo } from 'actions/worksheet-question-response';
import itemCorrectnessDictReducer from 'comps/learnosity/v1/reducers/question-correctness';
import WidgetOriginalHeightReducer from 'comps/learnosity/v1/reducers/question-widget-height';
import { combineReducers } from 'redux';

import activeStudent from './active-student';
import analyticsTraceReducer from './analytics-trace-reducer';
import appConfigReducer from './app-config';
import attemptingQuesPayload from './attempting-questions-payload';
import authReducer from './auth';
import AuthBgConfigReducer from './auth-bg-config';
import avSessionTokenReducer from './av-session-token';
import awsSignedKeyReducer from './aws-signed-key';
import chapterReducer from './chapter';
import chatEventsReducer from './chat-events';
import chatSoundReducer from './chat-sound';
import chatWindowReducer from './chat-window';
import ClassRecordingReducer from './class-recording-reducer';
import classStatusReducer from './class-status';
import clientEventReducer from './client-notification';
import completionCeremonyReducer from './completion-ceremony';
import controlChatPositioning from './control-chat-positioning';
import cueAnalyticsReducer from './cue-analytics';
import CueBoardReducer from './cue-board';
import CurrentSheetItemReducer from './current-sheet-item';
import curriculumReducer from './curriculum';
import curriculumHomeReducer from './curriculum-home-details';
import DemoReportReducer from './demo-report';
import DisableGroupChatReducer from './disable-group-chat';
import EnableGroupChatReducer from './enable-group-chat';
import eventNotificationReducer from './event-notification';
import eventTriggeredModalReducer from './event-triggered-modal';
import eventsTrackerReducer from './events-tracker';
import HitAnimationReducer from './hit-animation';
import homeDetailsReducer from './home-details';
import leaderboardReducer from './leaderboard';
import LearnosityConfigReducer from './learnosity-config';
import liveClassConfigReducer from './live-class-config';
import mathCanvasSyncReducer from './math-canvas-sync';
import MileStoneCreation from './milestone-creation';
import MileStoneEdit from './milestone-edit';
import MileStoneReviewId from './milestone-review';
import modalReducer from './modal';
import NotificationReducer from './notification';
import notificationHomeReducer from './notification-home';
import notificationHomeDataReducer from './notification-home-data';
import ParentProfileReducer from './parent-profile';
import PerfectHitReducerV2 from './perfect-hit';
import planetUIReducer from './planet-ui';
import polypadToolStatesReducer from './polypad-tool-states';
import preSHCModalReducer from './pre-shc-modal';
import programsReducer from './programs';
import ptmSlideEventActions from './ptm-screens';
import PuzzlesReducer from './puzzles';
import questionInsightsReducer from './question-insights-reducer';
import receiveClassChatMessageReducer from './receive-class-chat-message';
import receiveTeacherChatMessageReducer from './receive-teacher-chat-message';
import receiveTeacherReadChatMessageReducer from './receive-teacher-read-chat-message';
import recordSystemHealthCheckReducer from './record-system-health-check';
import RestReducer from './reducer';
import rewardsHomeReducer from './rewards-home';
import sendClassChatMessageReducer from './send-class-chat-message';
import sendTeacherChatMessageReducer from './send-teacher-chat-message';
import sendTeacherReadChatMessageReducer from './send-teacher-read-chat-message';
import mediaProviderReducer from './set-media-provider';
import consecutiveCountReducer from './sheet-correct-answer-count';
import SheetInfoReducer from './sheet-info';
import sheetModalReducer from './sheet-modal';
import sideModalReducer from './side-modal';
import SnackbarReducer from './snackbar';
import spStateReducer from './sp-state-reducer';
import startSpeedTestReducer from './start-speed-test';
import statusReducer from './status';
import studentAlertsReducer from './student-alerts';
import studentEventsReducer from './student-events';
import studentsReducer from './students';
import TalkMeterReducer from './talk-meter';
import teacherCallReducer from './teacher-call';
import TeacherControlReducer from './teacher-control';
import TeacherNetworkStatusReducer from './teacher-network-status';
import teacherStreams from './teacher-streams';
import toastReducer from './toast-msg';
import TrialHomeReducer from './trial-home-reducer';

export default combineReducers({
  activeStudent: activeStudent,
  auth: authReducer,
  appConfig: appConfigReducer,
  activityItems: RestReducer(activityItemsActions),
  attemptingQuestionsPayload: attemptingQuesPayload,
  avSessionToken: avSessionTokenReducer,
  avMonitor: RestReducer(avMonitorActions),
  avSessions: RestReducer(avSessionsActions),
  avTokens: RestReducer(avTokensActions),
  awsSignedKey: awsSignedKeyReducer,
  belts: RestReducer(beltsActions),
  consecutiveCount: consecutiveCountReducer,
  chapter: chapterReducer,
  chatBoxPositioning: controlChatPositioning,
  chatSound: chatSoundReducer,
  chatWindow: chatWindowReducer,
  classStatus: classStatusReducer,
  classrooms: RestReducer(classroomActions),
  classroomStudents: RestReducer(classroomStudents),
  clientEvent: clientEventReducer,
  completionCeremony: completionCeremonyReducer,
  configs: RestReducer(configActions),
  cueAnalyticsData: cueAnalyticsReducer,
  cueBoard: CueBoardReducer,
  currentSheetItem: CurrentSheetItemReducer,
  perfectHits: PerfectHitReducerV2,
  curriculum: curriculumReducer,
  curriculumHome: curriculumHomeReducer,
  curriculumPrograms: RestReducer(curriculumPrograms),
  demoFeedback: RestReducer(demoFeedbackActions),
  demoReport: DemoReportReducer,
  disableGroupChat: DisableGroupChatReducer,
  discipline: RestReducer(disciplineActions),
  enableGroupChat: EnableGroupChatReducer,
  examHelpSheets: RestReducer(schoolExamHelpSheetsActions),
  examLearnosityQuestions: RestReducer(examLearnosityQuestionsActions),
  examLearnosityItems: RestReducer(examItemsActions),
  eventNotification: eventNotificationReducer,
  eventTriggeredModal: eventTriggeredModalReducer,
  events: RestReducer(eventActions),
  eventsTracker: eventsTrackerReducer,
  examPerformance: RestReducer(examPerformance),
  liveClassConfig: liveClassConfigReducer,
  feedback: RestReducer(feedbackActions),
  feedbackTags: RestReducer(feedbackTagActions),
  gatekeeper: RestReducer(gatekeeperActions),
  healthCheckData: RestReducer(addHealthCheckData),
  hmsTokens: RestReducer(hmsTokenActions),
  homeDetails: homeDetailsReducer,
  widgetCorrectnessDict: itemCorrectnessDictReducer,
  journeys: RestReducer(journeysActions),
  leaderBoard: leaderboardReducer,
  learnosityConfigData: LearnosityConfigReducer,
  learnosityQuestions: RestReducer(learnosityQuestionsActions),
  learnositySessions: RestReducer(learnositySessionAction),
  learnosityWidgets: RestReducer(learnosityWidgetsActions),
  login: RestReducer(loginActions),
  authBgConfig: AuthBgConfigReducer,
  logout: RestReducer(logoutActions),
  logoutEverywhere: RestReducer(logoutEverywhereActions),
  mediaProvider: mediaProviderReducer,
  milestoneCreation: MileStoneCreation,
  mileStoneEdit: MileStoneEdit,
  mileStoneReviewId: MileStoneReviewId,
  modal: modalReducer,
  sideModal: sideModalReducer,
  monthlyProgress: RestReducer(monthlyProgress),
  monthlyProgressV2: RestReducer(monthlyProgressV2),
  notification: NotificationReducer,
  notificationHome: notificationHomeReducer,
  notificationHomeData: notificationHomeDataReducer,
  openChatWindow: chatEventsReducer,
  otp: RestReducer(otpActions),
  parentOTP: RestReducer(parentOTP),
  parentProfileInfo: ParentProfileReducer,
  passwordResetToken: RestReducer(passwordResetTokenAction),
  planetUI: planetUIReducer,
  polypadToolStates: polypadToolStatesReducer,
  practice: RestReducer(practiceActions),
  preSHCModal: preSHCModalReducer,
  precallAnalysis: RestReducer(precallAnalysisActions),
  primaryMediaProvider: RestReducer(primaryMediaProviderActions),
  program: RestReducer(programActions),
  programs: programsReducer,
  ptmSlideEvent: ptmSlideEventActions,
  ptmSlide: RestReducer(ptmActions),
  ptmScheduledDate: RestReducer(ptmScheduledDate),
  ptmFeedback: RestReducer(ptmFeedbackActions),
  puzzles: PuzzlesReducer,
  questionInsights: questionInsightsReducer,
  receiveClassChatMessage: receiveClassChatMessageReducer,
  receiveTeacherChatMessage: receiveTeacherChatMessageReducer,
  receiveTeacherReadChatMessage: receiveTeacherReadChatMessageReducer,
  recordSystemHealthCheck: recordSystemHealthCheckReducer,
  rewards: rewardsHomeReducer,
  sendClassChatMessage: sendClassChatMessageReducer,
  sendTeacherChatMessage: sendTeacherChatMessageReducer,
  sendTeacherReadChatMessage: sendTeacherReadChatMessageReducer,
  sheetInfo: SheetInfoReducer,
  sheetModal: sheetModalReducer,
  sheets: RestReducer(sheetActions),
  showHitAnimation: HitAnimationReducer,
  snackbar: SnackbarReducer,
  status: statusReducer,
  startSpeedTest: startSpeedTestReducer,
  student: studentsReducer,
  studentAlerts: studentAlertsReducer,
  studentClassActivities: RestReducer(studentClassActivitiesAction),
  studentCourses: RestReducer(studentCoursesActions),
  studentEvents: studentEventsReducer,
  studentNode: RestReducer(studentNodeAction),
  studentQuestionsSignedKey: RestReducer(studentQuestionsSignedKey),
  talkMeter: TalkMeterReducer,
  teacher: RestReducer(teacherActions),
  teacherBadges: RestReducer(teacherBadgesActions),
  teacherCall: teacherCallReducer,
  teacherControl: TeacherControlReducer,
  teacherNetworkStatus: TeacherNetworkStatusReducer,
  teacherStudents: RestReducer(teacherStudents),
  teacherStreams: teacherStreams,
  toastMessage: toastReducer,
  vibe: RestReducer(vibeActions),
  videoUrl: RestReducer(videoResumeUrl),
  whiteboards: RestReducer(whiteboardActions),
  worksheetAttempts: RestReducer(worksheetAttemptsActions),
  worksheets: RestReducer(worksheetActions),
  worksheetCurriculum: RestReducer(worksheetCurriculumActions),
  analyticsTrace: analyticsTraceReducer,
  learnosityPrefetch: RestReducer(prefetchSheetActions),
  predictveSheets: RestReducer(predictiveSheetPost),
  masteryPlan: RestReducer(masteryPlanActions),
  WidgetsHeight: WidgetOriginalHeightReducer,
  worksheetQuestionResponse: RestReducer(worksheetQuestionResponseInfo),
  mathCavasSyncReducer: mathCanvasSyncReducer,
  ugsExperienceConfig: RestReducer(ugsExperienceConfigActions),
  spState: spStateReducer,
  classRecordings: ClassRecordingReducer,
  trialHome: TrialHomeReducer,
});
